import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const FilterTab = ({ active, onClick, children }) => (
  <button
    type      = "button"
    onClick   = {onClick}
    className = {`h-8 px-3 rounded-md text-[13px] font-medium transition ${
      active
        ? "bg-brand-500 text-white"
        : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
    }`}
  >
    {children}
  </button>
)

const FilterBar = ({ search, onSearchChange, statusFilter, onStatusChange, statuses }) => (
  <div className="flex items-center gap-4 px-4 py-3 border-b border-slate-200">
    <div className="relative flex-shrink-0 w-72">
      <FontAwesomeIcon
        icon      = "magnifying-glass"
        className = "absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-[12px]"
      />
      <input
        type        = "text"
        value       = {search}
        onChange    = {event => onSearchChange(event.target.value)}
        placeholder = {I18n.t("workorders.filter_button", { defaultValue: "Rechercher" })}
        className   = "w-full h-9 pl-9 pr-3 bg-white border border-slate-200 rounded-md text-[13px] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-brand-500 focus:ring-[3px] focus:ring-brand-500/20"
      />
    </div>

    <div className="flex items-center gap-1 overflow-x-auto">
      <FilterTab
        active  = {statusFilter === ""}
        onClick = {() => onStatusChange("")}
      >
        {I18n.t("projects.index.filters.all", { defaultValue: "Tous" })}
      </FilterTab>
      {statuses.map(status => (
        <FilterTab
          key     = {status}
          active  = {statusFilter === status}
          onClick = {() => onStatusChange(status)}
        >
          {I18n.t(`mbc_contracts.status.${status}`, { defaultValue: status })}
        </FilterTab>
      ))}
    </div>
  </div>
)

export default FilterBar
